import { WrappedFieldProps, WrappedFieldInputProps } from 'redux-form'
import TextField, { TextFieldOwnProps } from 'components/atoms/inputs/TextField'
import { prepareFieldErrors } from 'helpers/formHelpers'
import { State } from 'interfaces/state'
import { Omit } from 'interfaces/index'

type TextFieldRedeclaredProps =
  | 'value'
  | 'errors'
  | 'errored'
  | 'active'
  | 'touched'
  | 'submitFailed'
  | 'onChange'
  | 'autoFocus'
type InheritedTextFieldOwnProps = Omit<TextFieldOwnProps, TextFieldRedeclaredProps>
export type TextFieldWrappedOwnProps = InheritedTextFieldOwnProps & {
  forceAutoFocus?: boolean
  onValueChange?: (value: string) => void
}

export type TextFieldWrappedProps = WrappedFieldProps<State> & TextFieldWrappedOwnProps

const TextFieldWrapped = (props: TextFieldWrappedProps) => {
  const { input, meta, onValueChange } = props
  const { active, touched, error, submitFailed } = meta

  const errors = prepareFieldErrors(error, Boolean(touched || submitFailed))
  const { onChange, ...restInput } = input as WrappedFieldInputProps

  return (
    <TextField
      errors={ errors }
      errored={ touched && errors.length > 0 }
      active={ active }
      touched={ touched }
      submitFailed={ submitFailed }
      onChange={ (e) => {
        const { currentTarget } = e
        if (onValueChange) {
          onValueChange(currentTarget ? currentTarget.value : '')
        }
        onChange(e)
      } }
      { ...props }
      { ...restInput }
    />
  )
}

export default TextFieldWrapped

